import {
    ApiSpinTogetherDisplayConfigAnySchema,
    ApiSpinTogetherFriendStateAnySchema,
    ApiSpinTogetherInviteSchema,
    ApiSpinTogetherPreferenceSchema,
    ApiSpinTogetherRewardAnySchema,
} from "@bridge-applications/pb-types";
import { z } from "zod";

export const SpinTogetherSliceSchema = z.object({
    preference: ApiSpinTogetherPreferenceSchema.nullable(),
    config: ApiSpinTogetherDisplayConfigAnySchema.nullable(),
    friends: z.array(ApiSpinTogetherFriendStateAnySchema),
    invites: z.array(ApiSpinTogetherInviteSchema),
    recentRewards: z.array(ApiSpinTogetherRewardAnySchema).max(20),
    loadStatus: z.enum(["idle", "loading", "ready", "error"]),
    realtimeStatus: z.enum(["disabled", "connecting", "connected", "polling"]),
    mutationStatus: z.enum(["idle", "saving", "error"]),
    error: z.string().nullable(),
    observedAt: z.string().nullable(),
    lastSequence: z.string(),
});

export type SpinTogetherSlice = z.infer<typeof SpinTogetherSliceSchema>;
